var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m22.5 5v-3.2",
  fill: "none",
  stroke: "#f2c14e",
  strokeWidth: 1.9,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m13.3 8.8-2.5-2.5",
  fill: "none",
  stroke: "#f2c14e",
  strokeWidth: 1.9,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m31.7 8.8 2.5-2.5",
  fill: "none",
  stroke: "#f2c14e",
  strokeWidth: 1.9,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m9.5 18h-3.5",
  fill: "none",
  stroke: "#f2c14e",
  strokeWidth: 1.9,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m35.5 18h3.5",
  fill: "none",
  stroke: "#f2c14e",
  strokeWidth: 1.9,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 18,
  r: 11.5,
  fill: "#a8352a"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 18,
  r: 9.8,
  fill: "#d84338"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 18,
  r: 3.1,
  fill: "#a8352a"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 18,
  r: 1.2,
  fill: "#dfe6ec"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 21.6,
  y: 28,
  width: 1.8,
  height: 3.2,
  rx: 0.9,
  fill: "#5c6870"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 32,
  r: 1.9,
  fill: "#5c6870"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 35,
  width: 13,
  height: 2.6,
  rx: 1.3,
  fill: "#8f9ba3"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 20.9,
  y: 33.5,
  width: 3.2,
  height: 2,
  fill: "#8f9ba3"
});

function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.4acf1afb9fe748437416cd380145c73d.svg";
export { ForwardRef as ReactComponent };